import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit, inject } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { ALL_SERVICES, COMMON_MODULES, IMAGES_URL, PLUS_MEMBERSHIP, ROUTES, LOGIN_PATH, CREAT_PASSWORD_PATH } from '@src/app/core/constants';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvBgContentComponent } from '@src/app/core/shared/components/mini-env/mini-env-bg-content/mini-env-bg-content.component';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MiniEnvTallInfoCardComponent } from '@src/app/core/shared/components/mini-env/mini-env-tall-info-card/mini-env-tall-info-card.component';
import { MiniEnvTestimonialsComponent } from '@src/app/core/shared/components/mini-env/mini-env-testimonials/mini-env-testimonials.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { MiniEnvInfoCardComponent } from '@src/app/core/shared/components/ui/cardbox/mini-env-info-card/mini-env-info-card.component';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as arsJson from '@src/assets/i18n/mini-env/ars/en.json';
import { MiniEnvTabsComponent } from "@src/app/core/shared/components/mini-env/mini-env-tabs/mini-env-tabs.component";
import { MiniEnvBenefitCardsComponent } from "@src/app/core/shared/components/mini-env/mini-env-benefit-cards/mini-env-benefit-cards.component";
import { HelperService } from '@src/app/core/services';

@Component({
  selector: 'app-ars',
  imports: [
    ...COMMON_MODULES,
    HeadingBlockOneModule,
    IconboxOneModule,
    IconboxTwoModule,
    HeadingBlockFullWidthModule,
    ImageboxOneModule,
    ImageboxFullwidthModule,
    CardboxOneModule,
    BannerOneModule,
    ImageboxBulletScrollComponent,
    MiniEnvHeadingBlockComponent,
    MiniEnvFaqsComponent,
    MiniEnvBannerComponent,
    MiniEnvSubFooterComponent,
    MembershipPlanModule,
    VideoPlayerComponent,
    MiniEnvContentBoxComponent,
    MiniEnvTestimonialsComponent,
    MiniEnvTallInfoCardComponent,
    MiniEnvBgContentComponent,
    MiniEnvTabsComponent,
    MiniEnvBenefitCardsComponent

  ],
  templateUrl: './ars.component.html',
  styleUrl: './ars.component.scss'
})
export class ArsComponent extends CoreClass implements OnInit {

  IMAGES_URL: string = IMAGES_URL;
  faqList = arsJson.FAQS.FAQ_LIST;
  imgSrc = 'assets/tenant-assets/mini-env/ars/Peoples-in-kitchen.png';
  bgClass = 'father-child-bg';
  helperService = inject(HelperService);


  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient
  ) {
    super(injector);
  }
  serviceDetails: any;
  All_SERVICES_PATH: string = ALL_SERVICES;
  services = [
    {
      id: '01',
      title: 'Medications',
      description: 'Free generics, with discounts on brand-name prescriptions.',
      icon: 'medicine (2) 1.png',
      isFree: true,
      link: ROUTES.pharmacy
    },
    {
      id: '02',
      title: 'Imaging',
      description: 'Clear, transparent, and discounted rates at 4,000+ labs nationwide.',
      icon: 'mri-machine 1.png',
      isFree: false,
      link: ROUTES.imaging
    },
    {
      id: '03',
      title: 'Procedures',
      description: 'Save 50%+ on procedures at 5,000+ surgery centers.',
      icon: 'robotic-surgery 1.png',
      isFree: false,
      link: ROUTES.surgical
    },
    {
      id: '04',
      title: 'Office Visits',
      description: 'Save up to 35% with 350k+ doctors nationwide.',
      icon: 'hospital (1) 1.png',
      isFree: false,
      link: ROUTES.officeVisit
    },


    {
      id: '05',
      title: 'Lab Tests',
      description: 'Save up to 60% at 2,100+ lab locations.',
      icon: 'test-tube 1.png',
      isFree: false,
      link: ROUTES.labTest
    },

  ];
  membershipPlanCode = 'WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP';
  benefits = [
    {
      id: '01',
      title: 'Flexibility',
      description: 'Access comprehensive in-person care that fits perfectly into your busy schedule and always meets your specific medical needs.',
      bgImage: 'd-shape'
    },
    {
      id: '02',
      title: 'Affordability',
      description: 'Pay direct with exclusive discounts, making care far more cost-effective than using any traditional health insurance plan.',
      bgImage: 'circles'
    },
    {
      id: '03',
      title: 'Transparency',
      description: 'Know your total cost upfront and pay at the time of service—absolutely no unexpected surprises and no bills in the mail.',
      bgImage: 'm-shape'
    },
  ];

  faqs: any[] = [
    {
      question: 'What is the difference between WoW Plus & health insurance?',
      answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
    },
    {
      question: 'Why do I need WoW Health?',
      answer: 'It provides affordable access to routine care and prescriptions...'
    }
  ];

  bannerSlides: any[] = [
    {
      title: 'Affordable Care, Exceptional Value',
      subtitle: 'From office visits to surgeries, experience premium care with transparent pricing and incredible discounts.',
      buttonText: ' Member Login',
      buttonAction: 'login',
      buttonAction2: 'first-login',
      buttonText2: 'First Time Login',
      bgImageUrl: 'assets/tenant-assets/mini-env/ars/ars-bg.png',
      link: '/join',
      bannerClass: 'ars-banner'
    }
  ];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    this.helperService.changeMiniEnvColor();
  }

  buttonAction() {
    const section = document.getElementById('membership-section');

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onSliderBtnAction(action: any) {
    if (action == 'login') {
      this.login();
    } else {
      this.router.navigate([CREAT_PASSWORD_PATH]);
    }
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

  async getService() {
    try {
      const services = await this.sharedService.getServicesForTabs();
      this.serviceDetails = services.find((s: any) => s.serviceCode === 'telehealth_services');
    } catch (error) {
      console.error('Error fetching services for tabs:', error);
    }
  }
  login() {
    this.router.navigate([LOGIN_PATH]);
  }
}
